import { put, call, takeLatest } from 'redux-saga/effects';
//import { push } from "connected-react-router";
import { actions } from './Reducer';
import { push } from 'react-router-redux';

import {
  setStatsLoadingAction,
  createArtisanStatsSuccessAction,
  createSupplierStatsSuccessAction,
  createAdminStatsSuccessAction,
  createSuperStatsSuccessAction,
  createCustomerStatsSuccessAction
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../notifications/Actions';

import * as api from './Api';

function* getArtisanStats({ payload: { id } }) {
  try {
    yield put(setStatsLoadingAction(true));
    const response = yield call(api.getArtisanStatistics, id);
    const { data } = response;
    const artisanStats = data;
    yield put(createArtisanStatsSuccessAction(artisanStats));
    // yield put(push('/supplier-categories'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setStatsLoadingAction(false));
  }
}
function* getSupplierStats({ payload: { id } }) {
  try {
    yield put(setStatsLoadingAction(true));
    const response = yield call(api.getSupplierStatistics, id);
    const { data } = response;
    const supplierStats = data;
    yield put(createSupplierStatsSuccessAction(supplierStats));
    // yield put(push('/supplier-categories'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setStatsLoadingAction(false));
  }
}
function* getCustomerStats({ payload: { id } }) {
  try {
    yield put(setStatsLoadingAction(true));
    const response = yield call(api.getCustomerStatistics, id);
    const { data } = response;
    const customerStats = data;
    yield put(createCustomerStatsSuccessAction(customerStats));
    // yield put(push('/supplier-categories'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setStatsLoadingAction(false));
  }
}
function* getSuperStats({ payload: { id } }) {
  try {
    yield put(setStatsLoadingAction(true));
    const response = yield call(api.getSuperStatistics, id);
    const { data } = response;
    const superStats = data;
    yield put(createSuperStatsSuccessAction(superStats));
    // yield put(push('/supplier-categories'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setStatsLoadingAction(false));
  }
}

function* getAdminStats({ payload: { id } }) {
  try {
    yield put(setStatsLoadingAction(true));
    const response = yield call(api.getAdminStatistics, id);
    const { data } = response;
    const adminStats = data;
    yield put(createAdminStatsSuccessAction(adminStats));
    // yield put(push('/supplier-categories'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setStatsLoadingAction(false));
  }
}
export default function*() {
  yield takeLatest(actions.GET_ARTISAN_STATS, getArtisanStats);
  yield takeLatest(actions.GET_SUPPLIER_STATS, getSupplierStats);
  yield takeLatest(actions.GET_SUPER_STATS, getSuperStats);
  yield takeLatest(actions.GET_ADMIN_STATS, getAdminStats);
  yield takeLatest(actions.GET_CUSTOMER_STATS, getCustomerStats);
}
